// Date 2023-06-26 13:00:19

import EmEmAdmUserGroupRoleList from "@/views/em/admin/EmEmAdmUserGroupRoleList";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
    {
        path: "/em/admin/userGroup/userGroupRoleList",
        name: "subUserList",
        component: EmEmAdmUserGroupRoleList,
        meta: metaObject
    }
]
